<template>
  <div>
    <ModalBase :show-modal="showModal" @close-modal="close" :auto-h="true" :narrow="true" :overlay-scrollb="false" class="bank-account-modal">
        <template v-slot:titlebar>
          <TitleBar variant-class="title-modal">
            <template v-slot:pretitle>
              {{ $gettext('EDIT') }}
            </template>
            <template v-slot:title>
              {{ $gettext('Bank Account settings') }}
            </template>
          </TitleBar>
        </template>

        <template v-slot:maincontent>
          <div class="content">
            <b-form @submit="saveForm">
              <b-form-row>
                <b-form-group 
                  id="input-alias-group"
                  class="w-100"
                  label-class="gk-label-margin gk-modal-label"
                  :label="$gettext('Account alias')"
                  label-for="input-alias"
                >
                  <b-form-input 
                    data-analytics-click
                    id="input-alias"
                    v-model="accountData.alias"
                    :placeholder="$gettext('Bank account alias')"
                  />
                </b-form-group>
              </b-form-row>
              <div class="d-flex justify-content-between align-items-center">
                <GekkoButton 
                  @click="close"
                  :text="$gettext('Cancel')" 
                  variant="link"
                  class="text-primary px-0"
                  size="sm"
                />
                <GekkoButton 
                  :text="$gettext('Save')" 
                  icon="fa-regular fa-save"
                  type="submit"
                  size="sm"
                />
              </div>
            </b-form>
          </div>
        </template>
    </ModalBase>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BankService from '@/store/services/bank.service.js';
import GekkoButton from '@/components/GekkoButton';
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: "BankConnectionModal",
  components: { GekkoButton, ModalBase, TitleBar, LoadingSpinner },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    accountData: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters ({ 
      isPremiumUser: "getIsPremium" // root getter
    })
  },
  created () {
  },
  methods: {
    close () {
      document.body.classList.remove('modal-on')
      this.$emit('close', false)
    },
    saveForm (e) {
      e.preventDefault()
      this.$emit('close', false)
      BankService.update(this.accountData.id, this.accountData).then(() => {
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.bank-account-modal .gk-modal {
  max-width: 400px !important;
}
</style>
<style lang="scss" scoped>

</style>